import { Col, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { MerchantDto } from 'src/generated-api-client';

type MerchantGeneralInfoCardProps = {
    merchant?: MerchantDto;
};

export const MerchantGeneralInfoCard = observer(
    ({ merchant }: MerchantGeneralInfoCardProps) => {
        return (
            <Card title={t('Merchant.GeneralInformation.Title')}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.Number')}
                            value={merchant?.number}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.ExternalMerchantId')}
                            value={merchant?.externalMerchantId}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.Name')}
                            value={merchant?.name}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.CreatedAt')}
                            value={merchant?.createdAt}
                            formatValue="dateTime"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('Merchant.PhoneNumbers')}
                            value={merchant?.phoneNumbers}
                            formatValue={(value: string[]) => value?.join(', ')}
                        />
                    </Col>
                </Row>
            </Card>
        );
    },
);
